// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","socialLinksWrapper":"Footer_socialLinksWrapper__IESrp","socialIconLink":"Footer_socialIconLink__ZWiG+","caption":"Footer_caption__YfVno"};